import { render, staticRenderFns } from "./AppCollapsibleContentSection.vue?vue&type=template&id=3a5cade4&scoped=true&"
import script from "./AppCollapsibleContentSection.vue?vue&type=script&lang=js&"
export * from "./AppCollapsibleContentSection.vue?vue&type=script&lang=js&"
import style0 from "./AppCollapsibleContentSection.vue?vue&type=style&index=0&id=3a5cade4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5cade4",
  null
  
)

export default component.exports